import "./menu.css";
import {
    RssFeed,
    Chat,
    PlayCircleFilledOutlined,
    Group,
    Bookmark,
    HelpOutline,
    WorkOutline,
    Event,
    School,
    SettingsPowerRounded,
} from "@mui/icons-material";
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import FeedbackIcon from '@mui/icons-material/Feedback';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, Link, Navigate } from "react-router-dom";
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { useContext, useEffect } from "react";
import SocialContext from "../../context/SocialContext";
import Topbar from "../topbar/Topbar";
import Bottom from "../Bottom/Bottom";
import Conform from "../conform/Conform";

export default function Menu() {
    const navigate = useNavigate();

    useEffect(() => {
        if (!window.localStorage.getItem('currentUID'))
            navigate('/');
    }, []);

    const { user: currentuser, logoutfun, setOpen, setconformMessage, setconformAction } = useContext(SocialContext);
    return (
        <>
            <Topbar />
            <Conform call={"forlogout"} />
            <div className="menu">
                <div className="sidebarWrapper">
                    <ul className="sidebarList" style={{ 'padding': '25px 50px' }}>
                        <li className="sidebarListItem">
                            <Link style={{'textDecoration':'none'}}  to={'/'} className="menulink"><HomeIcon className="sidebarIcon" /></Link>
                            <Link style={{'textDecoration':'none'}}  to={'/'} className="menulink"><span className="sidebarListItemText">Homepage</span></Link>
                        </li>
                        <li className="sidebarListItem">
                            <Link style={{'textDecoration':'none'}}  to={'/profile/' + currentuser._id} className="menulink"><PersonIcon className="sidebarIcon" /></Link>
                            <Link style={{'textDecoration':'none'}}  to={'/profile/' + currentuser._id} className="menulink"><span className="sidebarListItemText">My Account</span></Link>
                        </li>
                        <li className="sidebarListItem">
                            <Link style={{'textDecoration':'none'}}  to={'/share'} className="menulink"><AddCircleRoundedIcon className="sidebarIcon" /></Link>
                            <Link style={{'textDecoration':'none'}}  to={'/share'} className="menulink"><span className="sidebarListItemText">New Post</span></Link>
                        </li>
                        <li className="sidebarListItem">
                            <Link style={{'textDecoration':'none'}}  to={'/friends'} className="menulink"><Group className="sidebarIcon" /></Link>
                            <Link style={{'textDecoration':'none'}}  to={'/friends'} className="menulink"><span className="sidebarListItemText">Network</span></Link>
                        </li>
                        <li className="sidebarListItem">
                            <a style={{'textDecoration':'none'}} target="_blank" className="menulink" href="https://ekarts.netlify.app/"><LocalGroceryStoreIcon className="sidebarIcon" /></a>
                            <a style={{'textDecoration':'none'}} target="_blank" className="menulink" href="https://ekarts.netlify.app/"><span className="sidebarListItemText">Shop</span></a>
                        </li>
                        <li className="sidebarListItem">
                            <Link style={{'textDecoration':'none'}}  to={'/feedback'} className="menulink"><FeedbackIcon className="sidebarIcon" /></Link>
                            <Link  style={{'textDecoration':'none'}} to={'/feedback'} className="menulink"><span className="sidebarListItemText">Feedback</span></Link>
                        </li>
                        <li className="sidebarListItem" style={{ 'marginBottom': '0px' }}>
                            <LogoutIcon onClick={() => { setconformMessage("Do you want to logout"); setOpen(true); setconformAction("forlogout"); }} className="sidebarIcon" />
                            <span onClick={() => { setconformMessage("Do you want to logout"); setOpen(true); setconformAction("forlogout"); }} className="sidebarListItemText">Logout</span>
                        </li>
                    </ul>
                </div>
            </div>
            <Bottom />
        </>
    )
}
